import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { AirlineServicesAndIncentivesPageContent } from "./AirlineServicesAndIncentivesPageContent";
import { AirlineServicesAndIncentivesPageHeading } from "./AirlineServicesAndIncentivesPageHeading";
import { AirlineServicesFacilitiesNextPage } from "./AirlineServicesFacilitiesNextPage";
export const AirlineServicesAndIncentives = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "airlineServicesFacilitiesPageHeading",
      children: <AirlineServicesAndIncentivesPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "airlineServicesFacilitiesPageContent",
      children: <AirlineServicesAndIncentivesPageContent/>
    },
    {
      label: "Next Page",
      key: "airlineServicesFacilitiesNextPage",
      children: <AirlineServicesFacilitiesNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("thirdChildActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
